import React from 'react';
import PropTypes from 'prop-types';

const ContentTitleSection = props => {
    const {
        correct_responses: correctResponses,
        incorrect_responses: incorrectResponses,
        skipped_responses: skippedResponses,
    } = props.itemLevelDetails;
    return (
        <div className="content-title">
            <h2>
                <span>{props.title}</span>
            </h2>
            <div className="result">
                Correct <div className="score">{correctResponses}</div>{' '}
            </div>
            <div className="result">
                Incorrect <div className="score">{incorrectResponses}</div>
            </div>
            <div className="result">
                Skipped <div className="score">{skippedResponses}</div>
            </div>
        </div>
    );
};

ContentTitleSection.propTypes = {
    itemLevelDetails: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
};

export default ContentTitleSection;
